import { render, staticRenderFns } from "./CommissionList.vue?vue&type=template&id=c418f5e4&scoped=true"
import script from "./CommissionList.vue?vue&type=script&lang=js"
export * from "./CommissionList.vue?vue&type=script&lang=js"
import style0 from "./CommissionList.vue?vue&type=style&index=0&id=c418f5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c418f5e4",
  null
  
)

export default component.exports